export default string => [ ".", "#", "$", "/", "[", "]"].reduce((final_string, char) => final_string.split(char).join("-"), string)
